import { AccessRole, StakeholderRole } from '../../../types/stakeholder.types';

/**
 * Mirrors `SharedCapTableSharingAccessGuard`, so the action is not offered to someone the server
 * will refuse.
 *
 * The role, not the access role: an auditor has an `accessRole` and an ordinary stakeholder has
 * none, so gating on that field alone lets every plain stakeholder through. Auditors are then
 * excluded separately — a guest auditor is invited with a contributor role and would otherwise be
 * offered a button that 403s.
 */
const ROLES_ALLOWED_TO_SHARE = [StakeholderRole.ADMIN, StakeholderRole.CONTRIBUTOR];

export const canShareCapTable = (
  roleInCompany: StakeholderRole | undefined,
  accessRole?: AccessRole | null,
): boolean =>
  !!roleInCompany &&
  ROLES_ALLOWED_TO_SHARE.includes(roleInCompany) &&
  accessRole !== AccessRole.AUDITOR;
